import {Box, BoxProps, forwardRef} from "@chakra-ui/react";

const ContentWrapper = forwardRef((props: BoxProps, ref) => (
  <Box ref={ref} maxW="1200" mx="auto" px={[4, 8, 8, 8, 0]} {...props} />
));

export default ContentWrapper;
